<template>
<div>
    <div class="d-flex flex-column-fluid">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- height:auto - the theme stretches a gutter-b card to the column, which left a gap under the title -->
                    <div class="card card-custom gutter-b bg-transparent shadow-none border-0" style="height: auto">
                        <div class="card-header align-items-center border-bottom-dark px-0">
                            <div class="card-title mb-0">
                                <h3 class="card-label mb-0 font-weight-bold text-body">Каталоги B2B (PDF)</h3>
                            </div>
                        </div>
                    </div>

                    <!-- Upload. The title is taken from the file name when left empty. -->
                    <div class="card card-custom gutter-b bg-white border-0" style="height: auto">
                        <div class="card-body">
                            <h5 class="text-dark mb-3">Загрузить каталог</h5>
                            <div class="form-row align-items-end">
                                <div class="col-md-5 mb-2">
                                    <label class="text-dark">Название</label>
                                    <input type="text" class="form-control" v-model="newTitle" placeholder="например Haakaa catalogue 2026">
                                </div>
                                <div class="col-md-5 mb-2">
                                    <label class="text-dark">Файл PDF (до 60 МБ)</label>
                                    <!-- The admin theme hides a bare file input, so a button opens it. -->
                                    <div class="d-flex align-items-center">
                                        <label class="btn btn-light mb-0 text-nowrap">
                                            Выбрать файл
                                            <input type="file" accept="application/pdf,.pdf" ref="newFile" hidden @change="newFile = $event.target.files[0] || null">
                                        </label>
                                        <span class="ml-3 text-muted text-truncate" style="min-width:0">{{ newFile ? newFile.name : 'Файл не выбран' }}</span>
                                    </div>
                                </div>
                                <div class="col-md-2 mb-2">
                                    <button type="button" class="btn btn-primary w-100" :disabled="!newFile || busy" @click="upload">Загрузить</button>
                                </div>
                            </div>
                            <small class="form-text text-muted">Каталоги видят только вошедшие партнёры - в меню «Catalogues» на витрине и в подвале.</small>
                        </div>
                    </div>

                    <div class="card card-custom gutter-b bg-white border-0" style="height: auto">
                        <div class="card-body">
                            <div v-if="!catalogues.length" class="text-muted py-4 text-center">Каталогов пока нет.</div>
                            <table v-else class="table">
                                <thead>
                                    <tr>
                                        <th style="width:70px">Порядок</th>
                                        <th>Название</th>
                                        <th>Файл</th>
                                        <th style="width:90px">Страниц</th>
                                        <th style="width:90px">Размер</th>
                                        <th style="width:140px">Обновлён</th>
                                        <th style="width:260px"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(catalogue, index) in catalogues" :key="catalogue.id">
                                        <td>
                                            <button type="button" class="btn btn-sm btn-light px-2" :disabled="index === 0 || busy" @click="move(index, -1)" title="Выше">↑</button>
                                            <button type="button" class="btn btn-sm btn-light px-2" :disabled="index === catalogues.length - 1 || busy" @click="move(index, 1)" title="Ниже">↓</button>
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <input type="text" class="form-control form-control-sm" v-model="catalogue.title" @keyup.enter="rename(catalogue)">
                                                <button v-if="catalogue.title !== catalogue._savedTitle" type="button" class="btn btn-sm btn-primary ml-2" :disabled="busy" @click="rename(catalogue)">Сохранить</button>
                                            </div>
                                        </td>
                                        <td class="text-muted" style="word-break:break-all">{{ catalogue.file_name }}</td>
                                        <td>{{ catalogue.pages || '—' }}</td>
                                        <td>{{ catalogue.size_label }}</td>
                                        <td>{{ catalogue.updated_at }}</td>
                                        <td class="text-right text-nowrap">
                                            <button type="button" class="btn btn-sm btn-light" @click="download(catalogue)">Открыть</button>
                                            <label class="btn btn-sm btn-light mb-0">
                                                Заменить файл
                                                <input type="file" accept="application/pdf,.pdf" hidden @change="replace(catalogue, $event)">
                                            </label>
                                            <button type="button" class="btn btn-sm btn-light text-danger" :disabled="busy" @click="remove(catalogue)">Удалить</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            catalogues: [],
            newTitle: '',
            newFile: null,
            busy: false,
        };
    },
    computed: {
        config() {
            return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
        },
    },
    methods: {
        fetch() {
            this.$parent.loading = true;
            axios.get('/api/admin/b2b-catalogues', this.config)
                .then(res => {
                    this.catalogues = (res.data.data || []).map(c => ({ ...c, _savedTitle: c.title }));
                })
                .finally(() => (this.$parent.loading = false));
        },
        upload() {
            const form = new FormData();
            form.append('file', this.newFile);
            form.append('title', this.newTitle);
            this.busy = true;

            axios.post('/api/admin/b2b-catalogues', form, this.config)
                .then(() => {
                    this.$toaster.success('Каталог загружен');
                    this.newTitle = '';
                    this.newFile = null;
                    this.$refs.newFile.value = '';
                    this.fetch();
                })
                .catch(error => this.fail(error))
                .finally(() => (this.busy = false));
        },
        rename(catalogue) {
            if (!catalogue.title.trim()) {
                this.$toaster.error('Название не может быть пустым');
                return;
            }

            this.save(catalogue, { title: catalogue.title }, 'Название сохранено');
        },
        replace(catalogue, event) {
            const file = event.target.files[0];
            event.target.value = '';

            if (!file) {
                return;
            }

            const form = new FormData();
            form.append('file', file);
            this.save(catalogue, form, 'Файл заменён');
        },
        move(index, step) {
            // The whole order is written back, so it stays a clean 1..n.
            const list = this.catalogues.slice();
            const [item] = list.splice(index, 1);
            list.splice(index + step, 0, item);
            this.catalogues = list;
            this.busy = true;

            Promise.all(list.map((c, i) => axios.post(`/api/admin/b2b-catalogues/${c.id}`, { sort_order: i + 1 }, this.config)))
                .catch(error => this.fail(error))
                .finally(() => { this.busy = false; this.fetch(); });
        },
        save(catalogue, payload, message) {
            this.busy = true;

            axios.post(`/api/admin/b2b-catalogues/${catalogue.id}`, payload, this.config)
                .then(() => {
                    this.$toaster.success(message);
                    this.fetch();
                })
                .catch(error => this.fail(error))
                .finally(() => (this.busy = false));
        },
        remove(catalogue) {
            if (!confirm(`Удалить каталог «${catalogue.title}»? Партнёры больше не смогут его скачать.`)) {
                return;
            }

            this.busy = true;

            axios.delete(`/api/admin/b2b-catalogues/${catalogue.id}`, this.config)
                .then(() => {
                    this.$toaster.success('Каталог удалён');
                    this.fetch();
                })
                .catch(error => this.fail(error))
                .finally(() => (this.busy = false));
        },
        download(catalogue) {
            // Behind the admin token, so fetched as a file rather than linked.
            axios.get(`/api/admin/b2b-catalogues/${catalogue.id}/download`, { ...this.config, responseType: 'blob' })
                .then(res => {
                    const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                    window.open(url, '_blank');
                    setTimeout(() => URL.revokeObjectURL(url), 60000);
                })
                .catch(error => this.fail(error));
        },
        fail(error) {
            const data = error.response && error.response.data;
            const first = data && data.errors ? Object.values(data.errors)[0][0] : null;
            this.$toaster.error(first || (data && data.message) || 'Не удалось сохранить');
        },
    },
    mounted() {
        this.fetch();
    },
};
</script>
